import React from "react";
import DashboardBanner from "../clientSettings/tabs/dashboardbanner";



export const Dashboardbanner = (props) => {
    return (
        <DashboardBanner type="Dashboard" {...props} />
    )
}